import React, { useContext, useEffect, useState } from 'react'
// import { Link } from 'react-router-dom';
import json from './candidateData'
import { MyContext } from '../..';
import { useFormInputValidation } from "react-form-input-validation";
import Alert from 'react-bootstrap/Alert';

const CandidateRegister = (props) => {
    const queryParameters = new URLSearchParams(window.location.search)
    const subscriberCode = queryParameters.get("subcode") || props.subCode
    const { backendUrl } = useContext(MyContext)
    const [data, setData] = useState(null);
    const [message, setMessage] = useState(null)
    const [messageType, setMessageType] = useState("primary")
    const [show, setShow] = useState(false);
    const [fields, errors, form] = useFormInputValidation({
        first_name: "",
        last_name: "",
        email: "",
        phone_number: "",
        address: "",
        password: "",
        subscriber_code: subscriberCode
    }, {
        first_name: "required|alpha|between:3,25",
        last_name: "required|alpha|between:3,25",
        email: "required|email|between:3,50",
        phone_number: "required|numeric|digits_between:10,20",
        address: "required|between:10,200",
        password: "required|between:5,15",
    });
    
    useEffect(() => {
        setData(json)
    }, []);
    const onSubmit = async (event) => {
        const isValid = await form.validate(event);
        if (isValid) {
            try {
                const student = await fetch(`${backendUrl}/registration/candidate`, {
                    method: "POST",
                    body: JSON.stringify(fields),
                    mode: "cors",
                    headers: {
                        "Content-Type": "application/json"
                    }
                });
                const responseData = await student.json()
                if (student.ok) {
                    console.log("User Created");
                    setMessage(responseData.message)
                    setMessageType("success")
                    setShow(true)
                }
                else {
                    // const responseData = await student.json()
                    setMessage(responseData.message)
                    setMessageType("danger")
                    setShow(true)
                }
            } catch (error) {
                console.log(error);
            }
        }
        else {
            console.log(fields)
            console.log("validation not valid...");
            console.log("errors are", errors);
        }
    }

    return (
        <div className='container p-3'>
            <form
                className="myForm"
                noValidate
                autoComplete="off"
                onSubmit={onSubmit}
            >
                {show ? (
                    <Alert variant={messageType} onClose={() => setShow(false)} dismissible>
                        <Alert.Heading style={{textAlign: "center"}}>{message}</Alert.Heading>
                    </Alert>
                ) : (
                    null
                )}
                <div className="container justify-content-center d-flex row">
                    {
                        data &&
                        <div className='border p-4 rounded justify-content-center  col-9' style={{ color: data.font_color, backgroundColor: data.bg_color }} >

                            <div >
                                <h3 className='text-center '>{data.title}</h3>
                                <div className="row">
                                    {
                                        data.form_fields && data.form_fields.length > 0 &&
                                        data.form_fields.map((item, i) => (
                                            < div className="mb-1 col-md-6" key={i}>
                                                {
                                                    item.type !== "select" ?
                                                        <>
                                                            < label className="form-label fw-semibold ">{item.label}</label>
                                                            {
                                                                item.required ?
                                                                    <input type={item.type} required placeholder={item.placeholder} className="form-control form-control-sm" name={item.name} onBlur={form.handleBlurEvent} onChange={form.handleChangeEvent} value={fields.name} /> :
                                                                    <input type={item.type} placeholder={item.placeholder} className="form-control form-control-sm" name={item.name} onBlur={form.handleBlurEvent} onChange={form.handleChangeEvent} value={fields.name} />
                                                            }
                                                            <label className="error" style={{ color: "red" }}>
                                                                {errors[`${item.name}`]
                                                                    ? errors[`${item.name}`]
                                                                    : ""}
                                                            </label>
                                                        </>
                                                        :
                                                        <>
                                                            < label className="form-label fw-semibold ">{item.label}</label>
                                                            <select className="form-select" >
                                                                {
                                                                    item.options && item.options.map((option) => (
                                                                        <option value={option.value}>{option.name}</option>
                                                                    ))
                                                                }
                                                            </select>
                                                        </>
                                                }
                                            </div>
                                        ))
                                    }
                                </div>
                                <div className="row justify-content-center">
                                    {
                                        data.submit_btn &&
                                        <button className='btn col-3 mt-2' style={{ color: data.submit_btn.font_color, backgroundColor: data.submit_btn.bg_color }} type='submit'>{data.submit_btn.text}</button>
                                    }
                                </div>
                            </div>
                        </div>
                    }
                </div >
            </form>
        </div>

    )
}

export default CandidateRegister;


